import MainProgressBar from "./MainProgressBar";
import {ProgressBar} from "react-bootstrap";
import classNames from "classnames";
import React from "react";

class ColorBasedValueProgressBar extends MainProgressBar {
    render = () => {
        const {min, max, value} = this.props;
        const color = this.getColorFromValue();

        return <ProgressBar className={classNames(color)} min={min} max={max} now={value}/>
    };

    getColorFromValue = () => {
        const {value} = this.props;

        if (value <= 20)
            return 'low';
        else if (value <= 40)
            return 'medium';
        else
            return 'high';

    };
}

export default ColorBasedValueProgressBar;
